(() => {
  const selector = '.voicsky-tech-specs__tabs, .vis__tabs, .vwtb__countries, .vwtb__types';
  const controls = new Map();
  function connect(list) {
    if (controls.has(list)) return;
    let frame = 0;
    const update = () => {
      frame = 0;
      const active = list.querySelector('button[aria-selected="true"], button[aria-pressed="true"]');
      if (!active || !list.clientWidth) return;
      let indicator = list.querySelector(':scope > .vseg__indicator');
      if (!indicator) {
        indicator = document.createElement('span');
        indicator.className = 'vseg__indicator';
        indicator.setAttribute('aria-hidden', 'true');
        list.prepend(indicator);
      }
      const bounds = list.getBoundingClientRect(), rect = active.getBoundingClientRect();
      indicator.style.width = `${rect.width}px`;
      indicator.style.height = `${rect.height}px`;
      indicator.style.transform = `translate(${rect.left - bounds.left + list.scrollLeft - list.clientLeft}px, ${rect.top - bounds.top + list.scrollTop - list.clientTop}px)`;
      if (!list.hasAttribute('data-segmented-ready')) {
        list.setAttribute('data-segmented-ready', '');
        requestAnimationFrame(() => { if (list.isConnected) list.setAttribute('data-segmented-animate', ''); });
      }
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const observer = new MutationObserver(schedule);
    observer.observe(list, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-selected', 'aria-pressed'] });
    const resize = new ResizeObserver(schedule);
    resize.observe(list);
    const center = event => {
      const button = event.target.closest('button');
      if (!button || !list.contains(button) || !list.matches('.vwtb__countries, .vwtb__types')) return;
      const rect = button.getBoundingClientRect(), bounds = list.getBoundingClientRect();
      list.scrollBy({ left: rect.left - bounds.left - (list.clientWidth - rect.width) / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    list.addEventListener('click', center);
    list.addEventListener('resize', schedule);
    controls.set(list, () => { observer.disconnect(); resize.disconnect(); cancelAnimationFrame(frame); list.removeEventListener('click', center); list.removeEventListener('resize', schedule); });
    schedule();
  }
  function scan() {
    controls.forEach((dispose, list) => { if (!list.isConnected) { dispose(); controls.delete(list); } });
    document.querySelectorAll(selector).forEach(connect);
  }
  scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    controls.forEach((dispose, list) => { if (event.target.contains(list)) { dispose(); controls.delete(list); } });
  });
  document.fonts.ready.then(() => controls.forEach((_, list) => { list.dispatchEvent(new Event('resize')); }));
})();
